<template>
  <div class="steps has-text-centered">
    <vue-step
      style="z-index: 0"
      :active-color="'#424A60'"
      :now-step="type_formulaire==='simple'?steps.nowStep:steps.nowStepSection+1"
      :step-list="type_formulaire==='simple'?steps.stepsLength:steps.stepsLengthSection"
    ></vue-step>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vueStep from 'vue-step'
export default {
  components: {
    vueStep
  },
  name: 'Step',
  computed: {
    ...mapGetters(['steps', 'type_formulaire'])
  }
}
</script>

<style>
.v-step-item-number {
  width: 20px !important;
  height: 20px !important;
  font-size: 14px !important;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/formulaire/Step.vue